import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LoaderHandlerService, ServicecallService } from 'src/app';

@Component({
  selector: 'app-case-insights',
  templateUrl: './case-insights.component.html',
  styleUrl: './case-insights.component.css'
})
export class CaseInsightsComponent {
  
  htmlUrl: SafeResourceUrl;
  loading = true;
  caseInsightsUrl : any;
  urlParams: { vin: string, dtc: string, time: string };

  constructor(private _router: Router, private sanitizer: DomSanitizer, private _sharedService : ServicecallService, private _loaderHandler: LoaderHandlerService,
  ) {
    this.urlParams = this._router.getCurrentNavigation()?.extras.state?.['data'];
  }

  ngOnInit() {
    this.caseInsightsUrl = this._sharedService?.getConfiguration('analyticsUseCases')?.caseUrl ?? 'https://az0blob0idec0devqa.blob.core.windows.net/blob-file-idec-dev/Temp/Validops_phase2/Validops/U5_DTC_RCA_dashboard.html?sp=r&st=2025-10-14T02:52:38Z&se=2026-10-30T11:07:38Z&spr=https&sv=2024-11-04&sr=b&sig=LWLD2s6Wk7GU5ufanLkFCxW3F%2BC31GqjVAU6fOE4IUY%3D';    
    this.loading = true;
    this._loaderHandler.enableManualLoader();
    const formattedDate = new Date(this.urlParams?.time).toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
    const additionalParams = `&vin=${encodeURIComponent(this.urlParams?.vin)}&dtc=${encodeURIComponent(this.urlParams?.dtc)}&edate=${encodeURIComponent(formattedDate)}`;
    const fullUrl = this.caseInsightsUrl + additionalParams;
    this.htmlUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }

  /**
   * Handles back
   */
  handleBack() {
    this._router?.navigateByUrl('/case/caseList');
  }

  /**
   * Determines whether iframe load on
   */
  onIframeLoad() {
    setTimeout(() => {
      this._loaderHandler.disableManualLoader();
      this.loading = false;
    }, 100);
  }

  /**
   * Determines whether iframe error on
   */
  onIframeError() {
    this._loaderHandler.disableManualLoader();
    this.loading = false;
  }
}
